import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {useAiChatLayout} from '@AiChat/hooks/useAiChatLayout';
import type {AiChatPageClassNames} from '@AiChat/hooks/useAiChatPageClassNames.types';
import {useAiChatSeasonClassName} from '@AiChat/hooks/useAiChatSeasonClassName';
import styles from '@AiChat/ai-chat.module.scss';

export function useAiChatPageClassNames(): AiChatPageClassNames {
  const {state} = useAiChat();
  const {isMobileLayout} = useAiChatLayout();
  const seasonClassName = useAiChatSeasonClassName();
  const hasMessages = !!state.currentChatId;
  const isNewUserEmptyState = !hasMessages && !state.isReturningUser;

  const getFullScreenClassName = (): string => {
    const classNames = [styles.fullScreen];

    if (isNewUserEmptyState && !(isMobileLayout && state.isSidebarExpanded)) {
      classNames.push(styles.scrollable);
    }

    return classNames.join(' ');
  };

  const getPageContentClassName = (): string => {
    const classNames = [styles.pageContent, seasonClassName];

    if (isNewUserEmptyState) {
      classNames.push(styles.scrollable);
    }

    if (state.isAssetsView) {
      classNames.push(styles.assetsView);

      if (isMobileLayout) {
        classNames.push(styles.assetsViewSmall);
      }
    }

    return classNames.join(' ');
  };

  return {
    fullScreen: getFullScreenClassName(),
    pageContent: getPageContentClassName(),
    conversation: styles.conversation,
  };
}
